import { render } from "./FormTextarea.vue?vue&type=template&id=7551cccc&scoped=true&ts=true"
import script from "./FormTextarea.vue?vue&type=script&lang=ts"
export * from "./FormTextarea.vue?vue&type=script&lang=ts"

import "./FormTextarea.vue?vue&type=style&index=0&id=7551cccc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7551cccc"]])

export default __exports__